// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision.
// LOGIC PORTED from LC2's EngagementStakePay.js and EngagementCreditBuilder.js (commons/
// components/HomeTabs/Engagement/) — both were near-identical "title + label/value rows"
// panels, so they're consolidated into one reusable component here instead of two nearly
// duplicate files. Same shape ({title, items: [{label, value}]}), same "render nothing when
// empty" behavior.
import React from 'react';
import {Box, Divider, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const EngagementStatPanel = ({info = {}}) => {
    const items = Array.isArray(info.items) ? info.items : [];
    if (items.length === 0) return null;

    return (
        <Box sx={{flex: 1, border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', backgroundColor: tokens.color.white, p: 2}}>
            <Stack spacing={1.5} divider={<Divider />}>
                <Typography variant="subtitle1" fontWeight={600}>
                    {info.title ?? ''}
                </Typography>
                {items.map((entry, index) => (
                    <Stack key={`${entry.label}-${index}`} direction="row" justifyContent="space-between">
                        <Typography variant="body2">{entry.label}</Typography>
                        <Typography variant="body2" fontWeight={600}>
                            {entry.value}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

export default EngagementStatPanel;
